import React from 'react';
import { ESignature } from './eSignature';

import { usePurchaseContext } from 'QuoteApp/services/providers';

import styles from './styles.module.css';

type AgentSignatureContentType = {
  policyDocumentsSigned: boolean;
  documentSigningHandledByAgent: boolean;
};

export const AgentSignatureContent = (props: AgentSignatureContentType) => {
  const { policyDocumentsSigned, documentSigningHandledByAgent } = props;

  const {
    eSignatureSMSConsent,
    setESignatureSMSConsent,
  } = usePurchaseContext();

  return (
    <div className={styles.wrapper}>
      <div className={styles.mainSection}>
        <ESignature
          policyDocumentsSigned={policyDocumentsSigned}
          eSignatureSMSConsent={eSignatureSMSConsent}
          documentSigningHandledByAgent={documentSigningHandledByAgent}
          setESignatureSMSConsent={setESignatureSMSConsent}
        />
      </div>
    </div>
  );
};
